/* eslint-disable no-unused-vars */
import { useMutation, useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { GetInsumos } from "../../actions/Insumo";
import { GetPagos } from "../../actions/pagos";
import { GetProfesionales } from "../../actions/profesionales";
import { GoTriangleDown, GoTriangleUp } from "react-icons/go";

import ImagenCerrar from "../../images/cerrar.png";
import login from "../../images/login.jpg";
import { useProducto } from "../../actions/Producto";
import GetServicios from "../../actions/servicio";
import { PresupuestoId } from "../../actions/presupuesto";
import { CircleAlert } from "lucide-react";
import style from "../../styles/factura.module.css";

function ABMFacturas() {
   var urlFac = process.env.REACT_APP_URL_DIR + "factura";
   var urlPresup = process.env.REACT_APP_URL_DIR + "presupuesto";
   var kl = 0;

   const urlCliente = process.env.REACT_APP_URL_DIR + "cliente";
   const urlGC = process.env.REACT_APP_URL_DIR + "giftcardtat/doc";
   const location = useLocation();
   const { state } = location;
   const [usarGC, setUsarGC] = useState(false);
   const [facturable, setFacturable] = useState(false);
   const users = GetProfesionales();
   const [selectedFormaPago, setSelectedFormaPago] = useState(1); // o el valor por defecto
   const [servicioSeleccionado, setServicioSeleccionado] = useState(false);
   const [selectedInsumos, setSelectedInsumos] = useState([]);

   const [input, setInput] = useState({
      id: state ? state.id : 0,
      id_primary: state ? state.id_primary : 0,
      documento: state ? state.documento : 0,
      nombre: state ? state.nombre : "",
      email: state ? state.email : "",
      serv_id: state ? state.serv_id : 0,
      companyId: state ? state.companyId : 0,
      telefono: state ? state.telefono : "",
      cod_status: state ? state.cod_status : "1",
      cod_serv: state ? state.cod_serv : 0,
      tipoPago: state ? state.tipoPago : 1,
      presupuesto: state ? state.presupuesto : [],
      netoprod: state ? state.netoprod : 0,
      netoinsumo: state ? state.netoinsumo : 0,
      usuario: 0,
      observaciones: state ? state.observaciones : "",
      gc_id: state ? state.gc_id : 0,
      gc_total: state ? state.gc_total : 0,
   });

   const presupuesto = PresupuestoId(input.id);
   const [servicios, setServicios] = useState([]);
   const servicio = GetServicios();
   const mp = GetInsumos();
   const [insumos, setInsumos] = useState([]);
   const [productos, setProductos] = useState([]);
   const pago = GetPagos();
   const { GetProductos } = useProducto();
   const producto = GetProductos();

   const [pagos, setPagos] = useState(state ? state.pagos : 0);
   const [pagosSeleccionados, setPagosSeleccionados] = useState([]);
   const [importePagar, setImportePagar] = useState(0);

   const numberFormat = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });

   useEffect(() => {
      setInsumos(mp);

      if (input.id > 0) {
         setFacturable(true);
         console.log("presupuesto: ", presupuesto);
      }

      if (presupuesto?.servicios?.length > 0) {
         setServicios(presupuesto.servicios);
         input.cod_serv = presupuesto?.servicios[0]?.id_primary || 0;
         setSelectedFormaPago(presupuesto?.tipoPago || 1);
         setServicioSeleccionado(true);
      } else {
         setServicios(servicio);
      }

      if (presupuesto?.productos?.length > 0) {
         setProductos(producto);
      }

      if (presupuesto?.cliente && presupuesto.cliente.id > 0) {
         input.presupuesto.cliente.nombre = presupuesto.cliente.nombre || "";
         input.presupuesto.cliente.documento =
            presupuesto.cliente.documento || "";
         input.presupuesto.cliente.email = presupuesto.cliente.email || "";
         input.presupuesto.cliente.telefono =
            presupuesto.cliente.telefono || "";
      }

      setPagos(pago.data || []);

      const pagosGuardados = presupuesto?.Presupuestopagos || state?.pagos || [];
      console.log('pagosGuardados: ', pagosGuardados);
      console.log('pagos: ', pagos);
      if (Array.isArray(pagosGuardados) && pagosGuardados.length > 0) {
         const pagosNormalizados = pagosGuardados.map((p) => {
            const idPrimary = p.pagoIdPrimary || 0;
            const porcentajeRecargo = parseFloat(p.porcentajeRecargo || 0);
            const importeBase = parseFloat(p.importe || 0);
            const montoRecargo = parseFloat(p.montoRecargo ||0)
            const importeTotal = parseFloat(p.importeTotal  || 0)
            const pagoInfo = (pago.data || []).find((pg) => pg.id_primary === idPrimary);


            return {
               id_primary: idPrimary,
               descripcion: pagoInfo?.descripcion || "Pago",
               porcentajeRecargo,
               importe: importeBase,
               montoRecargo,
               importeTotal,
            };
         });
         console.log('pagosNormalizados: ', pagosNormalizados);

         setPagosSeleccionados(pagosNormalizados);
      } else {
         setPagosSeleccionados([]);
      }

      if (presupuesto?.observaciones) {
         input.observaciones = presupuesto.observaciones || "";
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [presupuesto, pago.data]);

   var tipoInsu = 2;
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "productotattoo";
   const urlSI = process.env.REACT_APP_URL_DIR + "Servins";
   const [factdet, setFactdet] = useState(() => {
      const initialFactdet = [];
      initialFactdet.insumos = [];
      initialFactdet.insumosadic = [];
      initialFactdet.gc_id = 0;
      initialFactdet.gc_total = 0;
      return initialFactdet;
   });
   const [servins, setServins] = useState([]);
   const [nombre, setName] = useState("");
   const [documento, setDocumento] = useState("");
   // const [gc_id, setGcId] = useState(0);

   const [descto, setDescto] = useState(0);
   const [recargo, setRecargo] = useState(0);
   const [recargoDes, setRecargoDes] = useState("");
   const [adelanto, setAdelanto] = useState(0);
   const [codrecargo, setCodrecargo] = useState(1);
   const [cotDolar, setDolar] = useState(0);
   const [onChange, setOnChange] = useState(false);
   const [verisumo, setVerinsumo] = useState(false);
   const [originalDolar, setOriginalDolar] = useState(null);
   const [verproducto, setVerproducto] = useState(true);
   const [insDirect, setInsDirect] = useState([]);

   const [data, setData] = useState(state ? state.productos : 0);
   var cabecera = "Orden Tattoo";
   var verproductos = true;
   var verremove = true;
   const cantlineas = 15;
   const [variosClie, setVariosClie] = useState([]);
   const [minlinea, setMinLinea] = useState(1);
   const [maxlinea, setMaxLinea] = useState(cantlineas);

   const navigate = useNavigate();
   var totalFactura = 0;
   var totalDscto = 0;
   var totalRecargo = 0;
   var metodo = "POST";
   var btnGrabar = true;
   var totInsumo = 0;
   var lastId = 0; // Ultimo id que mostre
   // Validaciones
   const [nombreError, setNombreError] = useState("");
   const [profesionalError, setProfesionalError] = useState("");
   const [documentoError, setDocumentoError] = useState("");
   const [productoError, setProducto] = useState("");

   function gotoFirst() {
      setMinLinea(0);
      setMaxLinea(cantlineas);
   }

   function gotoNext() {
      setMinLinea(maxlinea + 1);
      setMaxLinea(maxlinea + cantlineas);
   }
   function gotoPrevious() {
      setMinLinea(minlinea - cantlineas);
      setMaxLinea(maxlinea - cantlineas);
   }

   // Mutation Sector

   const { mutate: graboPresup } = useMutation({
      mutationFn: (newPost) => {
         // ✅ Determine method dynamically based on id_primary
         const requestMethod = input.id_primary !== 0 ? "PUT" : "POST";
         const requestUrl =
            input.id_primary !== 0
               ? `${urlPresup}/${input.id_primary}`
               : urlPresup;

         return fetch(requestUrl, {
            method: requestMethod,
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json());
      },
      onSuccess: () => {
         window.location.href = "/presupuestot";
      },
      onError: () => {
         alert("Error en datos ingresados");
      },
   });
   const {
      mutate: buscarCli,
      isPendingCli,
      isErrorCli,
   } = useMutation({
      mutationFn: (documento) =>
         fetch(`${urlCliente}/?documento=${documento}`, {
            method: "GET",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (cliente) => {
         input.documento = cliente[0].documento;
         input.nombre = cliente[0].nombre;
         input.telefono = cliente[0].telefono;
         input.email = cliente[0].email;

         setDocumento(input.documento);
      },
      onError: () => {
         alert("Cliente Nuevo: Por favor ingrese los datos");
      },
   });

   const {
      mutate: buscarGiftCard,
      isPendingGC,
      isErrorGC,
   } = useMutation({
      mutationFn: (documento) =>
         fetch(`${urlGC}/${documento}`, {
            method: "GET",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (clientegc) => {
         console.log('clientegc: ', clientegc);
         factdet.gc_id = clientegc.id;
         factdet.gc_total = clientegc.total;
         // setGcId(input.gc_id);
      },
      onError: (error) => {
        console.log('error: ', error);
        console.log("No se encontró Gift Card para el documento ingresado");
      },
   });



   const {
      mutate: buscarCliNombre,
      isPendingClinombre,
      isErrorClinombre,
   } = useMutation({
      mutationFn: (nombre) =>
         fetch(`${urlCliente}/?nombre=${nombre.toLowerCase()}`, {
            method: "GET",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (cliente) => {
         if (cliente.length > 1) {
            console.log("Cliente encontrado: muchos ", cliente.length);
            setVariosClie(cliente);
            return;
         }
         input.documento = cliente[0].documento;
         input.nombre = cliente[0].nombre;
         input.telefono = cliente[0].telefono;
         input.email = cliente[0].email;

         setDocumento(input.documento);
      },
      onError: () => {
         alert("Cliente Nuevo: Por favor ingrese los datos");
      },
   });

   const {
      mutate: buscarProdDuo,
      isPending2,
      isError2,
   } = useMutation({
      mutationFn: (nombre) =>
         fetch(`${url}/find/${nombre}`, {
            method: "GET",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (productosFiltrado) => {
         setProductos(productosFiltrado);
      },
      onError: () => {
         alert("Error");
      },
   });
   const {
      mutate: buscarProd,
      isPending,
      isError,
   } = useMutation({
      mutationFn: (nombre) =>
         fetch(`${url}?nombre=${nombre}`, {
            method: "GET",

            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (productosFiltrado) => {
         setProductos(productosFiltrado);
      },
      onError: () => {
         alert("Error");
      },
   });
   // Busco Servicios => Insumos
   const {
      mutate: buscarSI,
      isPending: penSi,
      isError: errSI,
   } = useMutation({
      mutationFn: (id) =>
         fetch(`${urlSI}/${id}`, {
            method: "GET",

            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (servins) => {
         var sumInsumos = 0;
         for (let index = 0; index < servins.length; index++) {
            sumInsumos +=
               parseFloat(servins[index].insumo.recargoCalculado).toFixed(2) *
               parseFloat(servins[index].cantidad);
            var pro = {
               id: 0,
               cantidad: 0,
               precio: 0,
               final: 0,
               tipoinsumo: 1,
            };
            pro.id = servins[index].insumoIdPrimary;
            pro.cantidad = servins[index].cantidad;
            pro.precio = parseFloat(servins[index].insumo.dolar).toFixed(2);
            pro.final =
               parseFloat(servins[index].insumo.recargoCalculado).toFixed(2) *
               parseFloat(servins[index].cantidad).toFixed(2);

            insDirect.push(pro);
            // console.log("pro: ", pro);
         }
         totInsumo = parseFloat(sumInsumos).toFixed(2);

         var initialProductLine = {
            id: 9999,
            tipo: 9999,
            descripcion: "Insumos",
            dolar: 0,
            precioLista: 0,
            cant: 1,
            tiposerv: 0,
         };
         initialProductLine.dolar = totInsumo;
         if (totInsumo > 0) {
            factdet.push(initialProductLine);
         }
      },
      onError: () => {
         alert("Error");
      },
   });

   // End Mutation Sector

   if (users) {
      if (users?.message === "Token inválido") {
         return (
            <>
               <div>
                  <br />
                  Por favor vuelva a Logonearse
                  <br />
               </div>
               <Link to={"/login"} className="dLink" title="Login">
                  <img src={login} height="90px" width="90px" alt="" />
               </Link>
               &nbsp;&nbsp;
            </>
         );
      }
   }
   const dollarUSLocale = Intl.NumberFormat("de-DE", {
      minimumIntegerDigits: 1,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
   });

   // Fin control Accesos
   var factura = {
      cliente: {
         documento: "",
         nombre: "",
         email: "",
         telefono: ",",
      },
      numeroFactura: 0,
      fecha: new Date().toLocaleDateString("en-GB"),
      tipoPago: 1, // leva codigo
      recargo: 0, // %
      recargoImp: 0, // %
      cotizacionDolar: 1260,
      descuento: 0, // en porcentaje
      descuentoImp: 0, // en porcentaje
      observaciones: "",
      total: 0,
      productos: [],
      servicios: [],
      insumos: [],
      insumosadic: [],
      adicionales: [],
      adelanto: 0,
      usuario: 0,
      netoprod: 0,
      netoinsumo: 0,
      pagosSeleccionados: pagosSeleccionados,
   };

   var initialProductLine = {
      id: 0,
      tipo: 2,
      descripcion: "",
      dolar: 0,
      precioOriginal: 0, //
      precioLista: 0, // precio actual * % de ganancia
      cantidad: 1,
      tiposerv: 0,
   };

   // OBTENGO DATOS DEL PRESUPUESTO

   if (
      presupuesto &&
      presupuesto?.servicios?.length > 0 &&
      factdet.length === 0
   ) {
      if (presupuesto?.servicios[0].id > 0) {
         console.log(
            "OBTENGO DATOS DEL PRESUPUESTO",
            presupuesto,
            factdet.length,
            presupuesto.servicios[0].id,
         );

         input.nombre = presupuesto.cliente.nombre;

         input.email = presupuesto.cliente.email;
         input.documento = presupuesto.cliente.documento;
         input.telefono = presupuesto.cliente.telefono;
         input.usuario = presupuesto.user.id_rank;
         input.observaciones = presupuesto.observaciones;
         initialProductLine.id = presupuesto.servicios[0].id;
         initialProductLine.tipo = 1;
         initialProductLine.descripcion = presupuesto.servicios[0].descripcion;

         initialProductLine.dolar =
            parseFloat(presupuesto.total) -
            parseFloat(presupuesto.recargoimporte) +
            parseFloat(presupuesto.descuentoimporte);
         initialProductLine.precioOriginal = presupuesto.servicios[0].dolar;
         initialProductLine.precioLista = presupuesto.servicios[0].precio;

         initialProductLine.tiposerv = 0;
         setRecargo(presupuesto.tipoPago);
         setRecargoDes(presupuesto.formaspago.descripcion);
         factdet.push(initialProductLine);

         var sumInsumos = 0;
         
         factdet.insumos = [];
         factdet.insumosadic = [];

         for (let i = 0; i < presupuesto.insumos.length; i++) {
            if (presupuesto.insumos[i].presupuestoinsumo.tipoinsumo === 1) {
               sumInsumos +=
                  parseFloat(presupuesto.insumos[i].recargoCalculado) *
                  parseFloat(presupuesto.insumos[i].presupuestoinsumo.cantidad);
               var prodLine22 = {
                  id: 0,
                  tipo: 3,
                  descripcion: "",
                  dolar: 0,
                  cantidad: 1,
                  tipoinsumo: 1,
               };
               prodLine22.id = presupuesto.insumos[i].id;
               prodLine22.descripcion = presupuesto.insumos[i].descripcion;
               prodLine22.dolar =
                  presupuesto.insumos[i].presupuestoinsumo.precioFijo;
               prodLine22.cantidad =
                  presupuesto.insumos[i].presupuestoinsumo.cantidad;

               factdet.insumos.push(prodLine22);
            }
         }

         // Insumos adicionales
         for (let i = 0; i < presupuesto.presupuestoinsumoadicionals.length; i++) {
            
               const insumoMp = mp?.find(
                  (item) => item.id_primary === presupuesto.presupuestoinsumoadicionals[i].insumo_id_primary,
               );

               var prodLine23Add = {
                  id: 0,
                  tipo: 3,
                  descripcion: "",
                  dolar: 0,
                  cantidad: 1,
                  tipoinsumo: 2,
               };
               prodLine23Add.id = insumoMp.id_primary
               prodLine23Add.descripcion = insumoMp?.descripcion 
               prodLine23Add.dolar =
                  presupuesto.presupuestoinsumoadicionals[i].precioFijo;
               prodLine23Add.cantidad =
                  presupuesto.presupuestoinsumoadicionals[i].cantidad;

               factdet.insumosadic.push(prodLine23Add);
               
               console.log(' factdet.insumosadic: ',  factdet.insumosadic);
            }
            
         var prodLine2 = {
            id: 9999,
            tipo: 9999,
            descripcion: "Insumos",
            dolar: 0,
            tiposerv: 0,
            cantidad: 1,
         };
         prodLine2.dolar = parseFloat(sumInsumos);
         factdet.push(prodLine2);

         // ahora muestro los insumos agregados

         for (let i = 0; i < presupuesto.insumos.length; i++) {
            if (presupuesto.insumos[i].presupuestoinsumo.tipoinsumo === 2) {
               var prodLine23 = {
                  id: presupuesto.insumos[i].id,
                  tipo: 3,
                  descripcion: presupuesto.insumos[i].descripcion,
                  dolar: presupuesto.insumos[i].presupuestoinsumo.precioFijo,
                  precioLista:
                     presupuesto.insumos[i].presupuestoinsumo.precioFijo,
                  cantidad: presupuesto.insumos[i].presupuestoinsumo.cantidad,
                  tipoinsumo: 2,
                  tiposerv: 0,
               };
               console.log("prodLine23: ", prodLine23);
               factdet.push(prodLine23);
            }
         }

         for (let i = 0; i < presupuesto.productos.length; i++) {
            var prodLine3 = {
               id: 0,
               tipo: 2,
               descripcion: "Productos",
               dolar: 0,
               tiposerv: 0,
               cantidad: 1,
               precioOriginal: 0,
            };
            prodLine3.id = presupuesto.productos[i].id;
            prodLine3.descripcion = presupuesto.productos[i].descripcion;
            prodLine3.dolar =
               presupuesto.productos[i].presupuestoproducto.precioFijo;
            prodLine3.cantidad =
               presupuesto.productos[i].presupuestoproducto.cantidad;
            prodLine3.precioOriginal = presupuesto.productos[i].valorPesos;

            factdet.push(prodLine3); //robin
         }
         for (let i = 0; i < presupuesto.adicionals.length; i++) {
            var prodLine4 = {
               id: 0,
               tipo: 9998,
               descripcion: "Adicionales",
               dolar: 0,
               tiposerv: 0,
               cantidad: 1,
            };
            prodLine4.id = presupuesto.adicionals[i].id;
            prodLine4.descripcion = presupuesto.adicionals[i].descripcion;
            prodLine4.dolar = presupuesto.adicionals[i].precioFijo;
            prodLine4.cantidad = presupuesto.adicionals[i].cantidad;
            factdet.push(prodLine4);
         }
         setDescto(presupuesto.descuento);
         setRecargo(presupuesto.recargo);
         setAdelanto(presupuesto.adelanto);
         console.log('factdet: ', factdet);
      }
   }

   if (!servicios || !insumos || !productos || !users) {
      return <div>Cargando datos</div>;
   }
   const getDolar = async () => {
      try {
         const response = await fetch(
            "https://api.bluelytics.com.ar/v2/latest",
         ); // Replace with your API endpoint
         if (!response) {
            throw new Error("Network response was not ok");
         }
         const dolar = await response.json();

         setDolar(dolar.blue.value_sell);
      } catch (error) {
         // setCotDolar(0);
         //setDolar(0);
      }
   };
   const toggleProducto = async () => {
      setVerproducto(!verproducto);
   };
   const toggleInsumo = async () => {
      setVerinsumo(!verisumo);
   };

   const handleCheck = (e, i) => {
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };

   const handlePrecio = (e, i) => {
      setFacturable(false);
      factdet[i.i].dolar = e.target.value;
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };

   const handleCant = (e, i) => {
      setFacturable(false);
      if (parseInt(tipoInsu) === 2 && parseInt(e.target.value) === 0) {
         //
         handleRemove(factdet[i.i].id, factdet[i.i].tipo);
         return;
      }

      factdet[i.i].cantidad = e.target.value;

      if (parseInt(factdet[i.i].tipo) === 2) {
         // Productos
         factdet[i.i].dolar = parseInt(
            factdet[i.i].dolar * factdet[i.i].cantidad,
         );
      }
      if (parseInt(factdet[i.i].tipo) === 3) {
         // Insumos
         console.log(
            "precioLista: ",
            factdet[i.i].precioLista,
            factdet[i.i].cantidad,
         );
         factdet[i.i].dolar = factdet[i.i].precioLista * factdet[i.i].cantidad;
      }
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };
   function handleSelectProd(id) {
      // e.preventDefault();
      for (let i = 0; i < productos.length; i++) {
         if (productos[i].id === id) {
            if (factdet) {
               for (let indx = 0; indx < factdet.length; indx++) {
                  if (
                     parseInt(factdet[indx].id) === parseInt(productos[i].id)
                  ) {
                     factdet[indx].cantidad += 1;
                     factdet[indx].precioLista = parseFloat(productos[i].dolar);
                     factdet[indx].dolar =
                        parseInt(productos[i].dolar) * factdet[indx].cantidad;
                     if (onChange) {
                        setOnChange(false);
                     } else {
                        setOnChange(true);
                     }
                     return;
                  }
               }
            }
            var initialProductLine = {
               id: 0,
               tipo: 2,
               descripcion: "",
               dolar: 0,
               precioOriginal: 0,
               precioLista: 0, // precio actual
               cantidad: 1,
            };
            initialProductLine.id = productos[i].id;
            initialProductLine.tipo = 2;
            initialProductLine.descripcion = productos[i].descripcion;
            initialProductLine.precioOriginal = parseFloat(productos[i].dolar);
            initialProductLine.precioLista = parseFloat(productos[i].dolar);
            initialProductLine.dolar = parseInt(productos[i].dolar);
            initialProductLine.tiposerv = 0;

            factdet.push(initialProductLine);

            if (onChange) {
               setOnChange(false);
            } else {
               setOnChange(true);
            }
         }
      }
   }

   // ✅ Update handleRemove to also remove from selectedInsumos
   const handleRemove = (id, tipo) => {
      var xx = 10000;
      if (tipo === 3) {
         handleRemoveInsumo(id);
         return 
      }

      for (let ix = 0; ix < factdet.length; ix++) {
         if (factdet[ix].id === id && factdet[ix].tipo === tipo) {
            xx = ix;
            break;
         }
      }

      if (xx !== 10000) {
         factdet.splice(xx, 1);

         // ✅ Remove from selected insumos if it's an insumo
         if (tipo === 3) {
            removeInsumoSelection(id);
         }
      }

      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };

   function handleInputDscto(e) {
      e.preventDefault();
      setDescto(e.target.value);

      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   }

   function handleServicio(e) {
      e.preventDefault();
      for (let i = 0; i < servicios.length; i++) {
         if (parseInt(servicios[i].id_primary) === parseInt(e.target.value)) {
            state.id = 1;
            input.serv_id = servicios[i].id;
            initialProductLine.id = servicios[i].id;
            initialProductLine.tipo = 1;
            initialProductLine.descripcion = servicios[i].descripcion;
            initialProductLine.dolar = parseFloat(servicios[i].precio);
            initialProductLine.precioOriginal = 0;
            initialProductLine.precioLista = servicios[i].precio;
            initialProductLine.tiposerv = servicios[i].tipo;

            factdet.push(initialProductLine);

            buscarSI(e.target.value);

            // ✅ Deshabilitar el select después de la selección
            setServicioSeleccionado(true);

            if (onChange) {
               setOnChange(false);
            } else {
               setOnChange(true);
            }
         }
      }
      setInput({
         ...input,
         cod_serv: e.target.value,
      });
   }

   function handleSelectPago(id_primary) {
      // Busca el pago en la lista
      const pago = pagos.find((p) => p.id_primary === id_primary);
      if (!pago) return;

      // Verifica si el pago ya está seleccionado
      const pagoExistente = pagosSeleccionados.find(
         (p) => p.id_primary === id_primary
      );

      if (pagoExistente) {
         // Si está seleccionado, lo quita
         setPagosSeleccionados(
            pagosSeleccionados.filter((p) => p.id_primary !== id_primary)
         );
      } else {
         // Si no está seleccionado, lo agrega
         // Calcula el importe: total actual - suma de otros pagos seleccionados
         let sumaOtrosPagos = 0;
         pagosSeleccionados.forEach((p) => {
            sumaOtrosPagos += p.importeTotal || p.importe || 0;
         });

         const importeBase = Math.max(0, totalFactura - sumaOtrosPagos);
         const montoRecargo = pago.recargo > 0 ? (importeBase * pago.recargo) / 100 : 0;
         const importeTotal = importeBase + montoRecargo;

         setPagosSeleccionados([
            ...pagosSeleccionados,
            {
               id_primary: id_primary,
               descripcion: pago.descripcion,
               porcentajeRecargo: pago.recargo || 0,
               importe: importeBase,
               montoRecargo: montoRecargo,
               importeTotal: importeTotal,
            },
         ]);
      }

      setImportePagar(totalFactura);
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   }

   function handleImportePago(id_primary, nuevoImporte) {
      setPagosSeleccionados(
         pagosSeleccionados.map((p) => {
            const importeBase =
               p.id_primary === id_primary
                  ? parseFloat(nuevoImporte) || 0
                  : p.importe;
            const montoRecargo =
               p.porcentajeRecargo > 0
                  ? (importeBase * p.porcentajeRecargo) / 100
                  : 0;
            const importeTotal = importeBase + montoRecargo;
            return { ...p, importe: importeBase, montoRecargo, importeTotal };
         })
      );
   }

   function handleSelectInsumos(id_primary) {
      console.log('id_primary: ', id_primary);
      console.log('INsumos: ', insumos);
      for (let i = 0; i < insumos.length; i++) {
         if (insumos[i].id_primary === id_primary) {
            console.log('IN factdet: ', factdet,insumos[i]);
            // Check if item already exists in factdet
            const existingIndex = factdet.insumosadic.findIndex(
               (item) => item.id === id_primary && item.tipo > 1,
            );
            
            if (existingIndex !== -1) {
               // Item exists, increase quantity
               factdet.insumosadic[existingIndex].cantidad += 1;
               factdet.insumosadic[existingIndex].dolar =
                  insumos[i].recargoCalculado *
                  factdet.insumosadic[existingIndex].cantidad;
            } else {
               // Item doesn't exist, add new
               var initialProductLine = {
                  id: id_primary,
                  tipo: 3,
                  descripcion: insumos[i].descripcion,
                  dolar: parseInt(insumos[i].recargoCalculado),
                  // precioLista: insumos[i].dolar,
                  tipoinsumo: 2,
                  cantidad: 1,
                  // tiposerv: 0,
               };
               console.log('initialProductLine: ', initialProductLine);
               factdet.insumosadic.push(initialProductLine);
               console.log('Out factdet: ', factdet);
            }
            
            // ✅ Update selected insumos state
            setSelectedInsumos((prev) => {
               const existing = prev.find((item) => item.id === id_primary);
               if (existing) {
                  // Increase quantity
                  return prev.map((item) =>
                     item.id === id_primary
                  ? { ...item, quantity: item.quantity + 1 }
                  : item,
               );
               } else {
                  // Add new selected item
                  return [
                     ...prev,
                     {
                        id: id_primary,
                        quantity: 1,
                        descripcion: insumos[i].descripcion,
                     },
                  ];
               }
            });

            if (onChange) {
               setOnChange(false);
            } else {
               setOnChange(true);
            }
            break;
         }
      }
   }
   const handleRemoveInsumo = (id_primary) => {
      // Remove any matching insumo rows from both collections.
      for (let i = factdet.length - 1; i >= 0; i--) {
         if (factdet[i].id === id_primary && factdet[i].tipo === 3) {
            factdet.splice(i, 1);
         }
      }

      if (Array.isArray(factdet.insumosadic)) {
         for (let i = factdet.insumosadic.length - 1; i >= 0; i--) {
            if (
               factdet.insumosadic[i].id === id_primary &&
               factdet.insumosadic[i].tipo === 3
            ) {
               factdet.insumosadic.splice(i, 1);
            }
         }
      }

      // Deselect in UI; Qty falls back to 0.
      removeInsumoSelection(id_primary);

      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };
  const handlebuscarCli = (documento) => {
      buscarCli(documento);
      buscarGiftCard(documento);
      setDocumento("");
   }  
   // ✅ Add function to remove insumo selection
   const removeInsumoSelection = (id_primary) => {
      
      console.log('removeInsumoSelection: ', selectedInsumos);
      setSelectedInsumos((prev) =>
         prev.filter((item) => item.id !== id_primary),
      );
   };
   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
      console.log("e.target.name : ", e.target.name, e.target.value);
      if (e.target.name === "Documento") {
         setDocumento(e.target.value);
      }
      if (e.target.name === "cliente") {
         console.log('estoy aqui');
         buscarCli(e.target.value);
         buscarGiftCard(e.target.value);
         setVariosClie([]);
         setDocumento("");
      }
      // setErrors(
      //    validate({
      //       ...input,
      //       [e.target.name]: e.target.value,
      //    })
      // );
   }

   function handleInputChange(e) {
      if (e.key === "Enter") {
         // setProductos([])
         if (nombre === "") {
            buscarProd(nombre);
         } else {
            buscarProdDuo(nombre);
         }

         setName("");
      }
   }

   function handleInputChangeCli(e) {
      console.log("input.documento: ", input.documento);
      if (e.key === "Enter") {
         buscarCli(input.documento);
         buscarGiftCard(input.documento);
         setDocumento("");
      }
   }

   // function handleInputChangeCliBlur(e) {
   //    console.log("input.documento: ", input.documento);
   //    if (input.documento !== "" && input.documento.length > 6) {
   //       buscarCli(input.documento);
   //       setDocumento("");
   //    }
   // }

   function handleInputChangeCliNombre(e) {
      if (e.key === "Enter") {
         console.log("input.nombre: ", input.nombre);
         buscarCliNombre(input.nombre);
         setName("");
      }
   }
   function handleInputChangeCliNombreBlur(e) {
      console.log("input.nombre: ", input.nombre);
      buscarCliNombre(input.nombre);
      setName("");
   }

   const handleSubmit = () => {
      var hayErr = "N";
      setNombreError("");
      setProfesionalError("");
      setDocumentoError("");
      setProducto("");
      var d = new Date();
      // Controles
      if (parseInt(input.usuario) === 0) {
         setProfesionalError("Debe ingresar un Profesional");
         hayErr = "S";
      }
      if (input.documento === "" || parseInt(input.documento) === 0) {
         setDocumentoError("Debe ingresar un Documento");
         hayErr = "S";
      }
      if (input.nombre === "" || input.nombre === undefined) {
         setNombreError("Debe ingresar Nombre");
         hayErr = "S";
      }
      if (input.email === "" || input.email === undefined) {
         input.email = " ";
      }
      if (factdet.length < 3 && factdet[0].id === 1) {
         setProducto("No ha Ingresado Productos");
         hayErr = "S";
      }
      
      if (hayErr === "S") {
         console.log(
            "hayerr: ",
            nombreError,
            profesionalError,
            documentoError,
            productoError,
         );
         
      } else {

         console.group("Datos para grabar factura");
         console.log('factdet: ', factdet);
         console.log('insDirect: ', insDirect);

         var newDate1 = factura.fecha.split("/");
         const newdate = newDate1[2] + "-" + newDate1[1] + "-" + newDate1[0];
         factura.fecha = newdate;
         factura.observaciones = input.observaciones;
         factura.netoinsumo = 0;
         factura.netoprod = 0;
         factura.gc_id = factdet.gc_id;
         factura.gc_total = factdet.gc_total;
         factura.tipo_presupuesto = 2;
         factura.pagos = pagosSeleccionados;
         // Insumos directo que usa el servicio
         for (let i = 0; i < insDirect.length; i++) {
            // console.log("insDirect[i]: ", insDirect[i]);
            var pro2 = {
               id: 0,
               cantidad: 0,
               precio: 0,
               tipoinsumo: 1,
            };
            pro2.id = insDirect[i].id;
            pro2.cantidad = parseInt(insDirect[i].cantidad);
            pro2.precio = parseInt(insDirect[i].precio);
            pro2.tipoinsumo = parseInt(insDirect[i].tipoinsumo);
            // factura.netoinsumo += insDirect[i].final;
            console.log("insDirect[i].final: ", pro2);
            factura.insumos.push(pro2);
         }

         if (factdet.insumos) {
            for (let i = 0; i < factdet.insumos.length; i++) {
               // console.log("factdet.insumos[i]: ", factdet.insumos[i]);
               var proIns = {
                  id: 0,
                  cantidad: 0,
                  precio: 0,
                  tipoinsumo: 1,
               };
               proIns.id = factdet.insumos[i].id;
               proIns.cantidad = factdet.insumos[i].cantidad;
               proIns.precio = factdet.insumos[i].precio;
               if (factdet.insumos[i].precio === undefined) {
                  proIns.precio = factdet.insumos[i].dolar;
               }
               factura.insumos.push(proIns);
            }
         }
         if (factdet.insumosadic) {
            for (let i = 0; i < factdet.insumosadic.length; i++) {
               // console.log("factdet.insumosadic[i]: ", factdet.insumosadic[i]);
               var proInsAdic = {
                  id: 0,
                  cantidad: 0,
                  precio: 0,
                  tipoinsumo: 1,
               };
               proInsAdic.id = factdet.insumosadic[i].id;
               proInsAdic.cantidad = parseFloat(factdet.insumosadic[i].cantidad);
               if (factdet.insumosadic[i].precio === undefined) {
                  proInsAdic.precio = parseFloat(factdet.insumosadic[i].dolar);
               } else {
                  proInsAdic.precio = parseFloat(factdet.insumosadic[i].precio);
               }
               factura.insumosadic.push(proInsAdic);
            }
         }

         factura.netoinsumo = 0;
         for (let i = 0; i < factdet.length; i++) {
            if (factdet[i].tipo > 1) {
               factura.netoinsumo += parseFloat(factdet[i].dolar);
            }
         }
         // Grabo Productos

         // Grabo Todos los Adicionales
         for (let i = 0; i < factdet.length; i++) {
            var pro = {
               id: 0,
               cantidad: 0,
               precio: 0,
               precioOriginal: 0,
               tipoinsumo: 2,
            };
            var adic = {
               descripcion: "",
               cantidad: 0,
               precio: 0,
            };
            pro.id = factdet[i].id;
            pro.cantidad = parseInt(factdet[i].cantidad);
            pro.precio = parseInt(factdet[i].dolar);
            if (factdet[i].tipo === 1) factura.servicios.push(pro);
            if (factdet[i].tipo === 2) {
               factura.netoprod += parseInt(factdet[i].dolar);
               pro.precioOriginal = parseInt(
                  factdet[i].dolar * factdet[i].cantidad,
               );
               factura.productos.push(pro);
            }
            // agrego insumos adicionales
            if (factdet[i].tipo === 3) {
               var existingItemIndex = factura.insumosadic.findIndex(
                  (item) => item.id === pro.id,
               );
               if (existingItemIndex !== -1) {
                  factura.insumosadic[existingItemIndex].cantidad += pro.cantidad;
                  factura.insumosadic[existingItemIndex].precio += pro.precio;
               } else {
                  factura.insumosadic.push(pro);
               }
            }
            // Cargos Adicionales
            if (factdet[i].tipo === 9998 || factdet[i].tipo === 9997) {
               adic.descripcion = factdet[i].descripcion;
               adic.cantidad = parseInt(factdet[i].cantidad);
               adic.precio = parseInt(factdet[i].dolar);
               factura.adicionales.push(adic);
            }
            if (parseInt(descto) !== 0) {
               factura.descuento = descto;
            }
            if (parseInt(recargo) !== 0) {
               factura.descuento = recargo;
            }
         }
         // Datos Cliente
         if (
            input.documento === "" ||
            input.documento === undefined ||
            input.documento === "0"
         ) {
            input.documento = d.toLocaleTimeString().replaceAll(":", "");
         }
         factura.cliente.documento = input.documento || "0";
         factura.cliente.nombre = input.nombre || "";
         factura.cliente.email = input.email || "";
         factura.cliente.telefono = input.telefono || "";

         factura.tipoPago = codrecargo;
         factura.recargo = recargo;
         factura.recargoImp = parseInt(totalRecargo);

         factura.descuento = descto;
         factura.descuentoImp = totalDscto;
         factura.adelanto = adelanto;
         factura.total = totalFactura;
         factura.usuario = input.usuario;
         factura.numeroFactura = input.id;

         factura.cotizacionDolar = parseInt(cotDolar);
         console.log('factura: ', factura);
         console.groupEnd();

         if (hayErr === "N") {
            graboPresup(factura);
         }
      }
   };

   if (cotDolar === 0) {
      getDolar();
   }

   if (data && productos.length === 0) setProductos(data);
   if (producto && productos.length === 0) setProductos(producto);
   if (penSi) return <div>Servicios cargando...</div>;
   if (isPending) return <div>Productos cargando...</div>;

   if (factdet) {
      if (factdet[0]) {
         totalFactura = parseInt(factdet[0].dolar);
      }
      // ERA SOLO PARA TATTOO
      // if (factdet[0]?.tiposerv === 2) {
      //    totalFactura = parseInt(factdet[0].dolar);
      // } else {
      //    factdet.map((data) => {
      //       totalFactura += parseInt(data.dolar);
      //    });
      // }
      if (descto > 0) {
         totalDscto = parseInt((totalFactura * descto) / 100);
         totalFactura = parseInt(totalFactura - (totalFactura * descto) / 100);
      }
      if (recargo > 0) {
         totalRecargo = parseInt((totalFactura * recargo) / 100);
         totalFactura = parseInt(totalFactura + (totalFactura * recargo) / 100);
      }
   }

   //
   if (isPending || isPendingCli) {
      return <div>Cargando datos...</div>;
   }
   if (factdet.length > 0) {
      if (factdet[0].tiposerv === 2) {
         // verproductos = false;
         tipoInsu = 2;
      }
   }

   //
   if (!insumos) {
      return <div>Cargando datos...</div>;
   }
   const totalPagosSeleccionados = pagosSeleccionados.reduce(
      (sum, p) => sum + (p.importeTotal || p.importe || 0),
      0,
   );
   const totalRecargosPagosSeleccionados = pagosSeleccionados.reduce(
      (sum, p) => sum + (p.montoRecargo || 0),
      0,
   );
   const totalPagosMenosRecargo =
   totalPagosSeleccionados - totalRecargosPagosSeleccionados;
   const diferenciaPagos = Math.abs(totalPagosSeleccionados - totalFactura);
   const diferenciaPagosMenosRecargo = Math.abs(
      totalPagosMenosRecargo - totalFactura,
   );
   const pagosCoinciden = diferenciaPagos < 0.01;
   const reglaHabilitarGrabar = diferenciaPagosMenosRecargo === 0;
   const botonDeshabilitado = !reglaHabilitarGrabar && !pagosCoinciden;
   const mostrarAvisoDiferencia =
   !reglaHabilitarGrabar && !pagosCoinciden && diferenciaPagos <= totalFactura;
   // console.log("pagos: ", pagos);
   console.log("factdet: ", factdet);
   // console.log("productos: ", productos);
   // console.log("input.cod_serv: ", input.cod_serv);
   console.log('totalFactura: ', totalFactura);
   console.log('diferenciaPagosMenosRecargo: ', diferenciaPagosMenosRecargo);
   console.log('totalPagosMenosRecargo: ', totalPagosMenosRecargo);
   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <h1 className="justify-self-center">{cabecera}</h1>
               <br />
               {!input.cod_serv ? (
                  <>
                     <div className={style.servicio}>
                        <table>
                           <tbody>
                              <tr className={style.cliente}>
                                 <td className={style.td1}>Servicio:</td>
                                 <td>
                                    <select
                                       className={style.selData}
                                       name="servicio"
                                       id="servicio"
                                       disabled={servicioSeleccionado} // ✅ Deshabilitar cuando esté seleccionado
                                       onChange={(e) => handleServicio(e)}
                                       value={input.cod_serv}
                                    >
                                       <option value="0">Seleccionar</option>
                                       {servicios &&
                                          servicios.map((data) => {
                                             if (data.tipo === 2) {
                                                return (
                                                   <option
                                                      value={data.id_primary}
                                                      key={data.id_primary}
                                                   >{`${data.descripcion}`}</option>
                                                );
                                             } else {
                                                return null;
                                             }
                                          })}
                                    </select>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </>
               ) : (
                  <div className={style.data}>
                     <div className={style.divIzq}>
                        <div>
                           <div>
                              <div className={style.cliente}>
                                 <table>
                                    <tbody>
                                       <tr>
                                          <td className={style.td1}>
                                             Servicio:
                                          </td>
                                          <td>
                                             <select
                                                className={style.selData}
                                                name="servicio"
                                                id="servicio"
                                                disabled={servicioSeleccionado} // ✅ Deshabilitar cuando esté seleccionado
                                                onChange={(e) =>
                                                   handleServicio(e)
                                                }
                                                value={input.cod_serv}
                                             >
                                                <option value="0">
                                                   Seleccionar
                                                </option>
                                                {servicios &&
                                                   servicios.map((data) => {
                                                      if (data.tipo === 2) {
                                                         return (
                                                            <option
                                                               value={
                                                                  data.id_primary
                                                               }
                                                               key={
                                                                  data.id_primary
                                                               }
                                                            >{`${data.descripcion}`}</option>
                                                         );
                                                      } else {
                                                         return null;
                                                      }
                                                   })}
                                             </select>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td className={style.td1}>
                                             Profesional:
                                          </td>
                                          <td>
                                             <select
                                                className={style.selData}
                                                name="usuario"
                                                id="usuario"
                                                onChange={handleChange}
                                                value={input.usuario}
                                             >
                                                <option value="0">
                                                   Seleccionar
                                                </option>
                                                {users &&
                                                   users.map((data) => {
                                                      return (
                                                         <option
                                                            selected
                                                            value={data.id_rank}
                                                            key={data.id_rank}
                                                         >{`${data.username}`}</option>
                                                      );
                                                   })}
                                             </select>
                                             <p className={style.errormsg}>
                                                {profesionalError}
                                             </p>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td className={style.td1}>
                                             Documento:
                                          </td>
                                          <td>
                                             <input
                                                onKeyDown={(e) =>
                                                   handleInputChangeCli(e)
                                                } // ✅ Modern approach
                                                // onBlur={(e) =>
                                                //    handleInputChangeCliBlur(e)
                                                // } // ✅ Modern approach
                                                type="text"
                                                className={style.clienteinput}
                                                placeholder="Ingrese documento"
                                                name="documento"
                                                value={input.documento}
                                                onChange={handleChange}
                                                required
                                             />
                                             <span
                                                style={{
                                                   marginLeft: "5px",
                                                   cursor: "pointer",
                                                }}
                                                title="Buscar"
                                                onClick={() => {
                                                   if (
                                                      !input.documento ||
                                                      input.documento === "0"
                                                   ) {
                                                      alert(
                                                         "Ingrese un documento primero",
                                                      );
                                                      return;
                                                   }
                                                   handlebuscarCli(input.documento);
                                                }}
                                             >
                                                <CircleAlert />
                                             </span>
                                             <p className={style.errormsg}>
                                                {documentoError}
                                             </p>
                                          </td>
                                       </tr>

                                       <tr>
                                          <td className={style.td1}>
                                             Nombre:{" "}
                                          </td>
                                          <td>
                                             <input
                                                onKeyDown={(e) =>
                                                   handleInputChangeCliNombre(e)
                                                }
                                                // onBlur={(e) =>
                                                //    handleInputChangeCliNombreBlur(
                                                //       e
                                                //    )
                                                // }
                                                type="text"
                                                className={style.clienteinput}
                                                placeholder="Ingrese nombre del Cliente"
                                                name="nombre"
                                                value={input.nombre}
                                                onChange={handleChange}
                                                required
                                             />
                                             <span
                                                style={{
                                                   marginLeft: "5px",
                                                   cursor: "pointer",
                                                }}
                                                title="Buscar"
                                                onClick={() => {
                                                   if (
                                                      !input.nombre ||
                                                      input.nombre === "0"
                                                   ) {
                                                      alert(
                                                         "Ingrese un nombre primero",
                                                      );
                                                      return;
                                                   }
                                                   buscarCliNombre(
                                                      input.nombre,
                                                   );
                                                }}
                                             >
                                                <CircleAlert />
                                             </span>
                                             <p className={style.errormsg}>
                                                {nombreError}
                                             </p>
                                          </td>
                                       </tr>
                                       {variosClie.length > 1 ? (
                                          <tr
                                             style={{
                                                backgroundColor: "#92f6a1ff",
                                             }}
                                          >
                                             <td className={style.td1}>
                                                Clientes:{" "}
                                             </td>
                                             <td>
                                                <select
                                                   className={
                                                      style.clienteinput
                                                   }
                                                   name="cliente"
                                                   onChange={handleChange}
                                                   required
                                                >
                                                   <option value="">
                                                      Seleccione un cliente
                                                   </option>
                                                   {variosClie.map((data) => {
                                                      return (
                                                         <option
                                                            value={
                                                               data.documento
                                                            }
                                                            key={data.documento}
                                                         >{`${data.documento} ${data.nombre}`}</option>
                                                      );
                                                   })}
                                                </select>
                                                <p className={style.errormsg}>
                                                   {profesionalError}
                                                </p>
                                             </td>
                                          </tr>
                                       ) : null}
                                       <tr>
                                          <td className={style.td1}>
                                             Telefono:
                                          </td>
                                          <td>
                                             <input
                                                type="text"
                                                className={style.clienteinput}
                                                placeholder="Ingrese Telefono"
                                                name="telefono"
                                                value={input.telefono}
                                                onChange={handleChange}
                                             />
                                          </td>
                                       </tr>
                                       <tr>
                                          <td className={style.td1}>
                                             {" "}
                                             Correo:{" "}
                                          </td>
                                          <td className={style.td500}>
                                             <input
                                                type="text"
                                                className={style.clienteinput}
                                                placeholder="Ingrese su email (opcional)"
                                                name="email"
                                                value={input.email}
                                                onChange={handleChange}
                                             />
                                          </td>
                                       </tr>
                                       {verproductos ? (
                                          <tr>
                                             <td className={style.td1}>
                                                {" "}
                                                Productos{" "}
                                             </td>
                                             <td className={style.td1}>
                                                <input
                                                   onKeyPress={(e) =>
                                                      handleInputChange(e)
                                                   }
                                                   onChange={(e) =>
                                                      setName(e.target.value)
                                                   }
                                                   type="text"
                                                   id="search-navbar"
                                                   placeholder="Buscar..."
                                                   value={nombre}
                                                />
                                                {verproducto ? (
                                                   <GoTriangleUp
                                                      onClick={() =>
                                                         toggleProducto()
                                                      }
                                                   />
                                                ) : (
                                                   <GoTriangleDown
                                                      onClick={() =>
                                                         toggleProducto()
                                                      }
                                                   />
                                                )}
                                                <p className={style.errormsg}>
                                                   {productoError}
                                                </p>
                                             </td>
                                          </tr>
                                       ) : null}
                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                        {/* ) : null} */}
                        {verproductos ? (
                           <>
                              <div
                                 className={
                                    verproducto
                                       ? style.producto
                                       : style.insumoHide
                                 }
                              >
                                 <table className={style.table1}>
                                    <tr>
                                       {/* <th>Codigo</th> */}
                                       <th>Descripcion</th>
                                       <th>Stock</th>
                                    </tr>
                                    {productos &&
                                       productos.map((data, indx) => {
                                          kl += 1;
                                          if (
                                             kl + 1 >= minlinea &&
                                             kl <= maxlinea
                                          ) {
                                             if (data.stock < 1) {
                                                kl -= 1;

                                                return null;
                                             }
                                             // console.log('data.tipoprod: ', data.descripcion,data.tipoprod);
                                             if (data.tipoprod < 3) {
                                                kl -= 1;
                                                return null;
                                             }
                                             return (
                                                <tr
                                                   key={data.id}
                                                   onClick={() =>
                                                      handleSelectProd(data.id)
                                                   }
                                                   className={style.trGrid}
                                                >
                                                   {/* <td className={style.td1}>
                                                   {data.id} 
                                                </td> */}
                                                   <td className={style.td2}>
                                                      {data.descripcion}
                                                   </td>
                                                   <td className={style.td4}>
                                                      {data.stock}
                                                   </td>
                                                </tr>
                                             );
                                          } else {
                                             return null;
                                          }
                                       })}
                                 </table>
                                 <div className={style.antsig}>
                                    <div>
                                       {maxlinea > cantlineas ? (
                                          <button
                                             className={style.inputBtnNew}
                                             onClick={() => gotoPrevious()}
                                          >
                                             Anterior
                                          </button>
                                       ) : // <p onClick={() => gotoPrevious()}>Anterior</p>
                                       null}
                                    </div>
                                    <div>
                                       {maxlinea < producto?.length ? (
                                          <button
                                             className={style.inputBtnNew}
                                             onClick={() => gotoNext()}
                                          >
                                             Siguiente
                                          </button>
                                       ) : // <p onClick={() => gotoNext()}>Siguiente</p>
                                       null}
                                    </div>
                                 </div>
                              </div>
                           </>
                        ) : null}
                        {input.cod_serv > 0 ? (
                           <>
                              <div>
                                 <div style={{ paddingLeft: "15px" }}>
                                    <button
                                       className={style.inputBtnNew}
                                       onClick={() => toggleInsumo()}
                                    >
                                       Insumo Adicional
                                    </button>
                                 </div>
                              </div>

                              <div
                                 // className={style.insumo} id="insumo"
                                 className={
                                    verisumo ? style.producto : style.insumoHide
                                 }
                              >
                                 <div>
                                    <table className={style.table1}>
                                       <tr>
                                          <th>Descripcion</th>
                                          <th>Stock</th>
                                          <th>Seleccionado</th>
                                       </tr>
                                       {mp &&
                                          mp?.map((data) => {
                                             var muestroreg = true;
                                             if (data.tipo < 2) {
                                                // es insumo de piercing
                                                muestroreg = false;
                                             }

                                             const selectedItem =
                                                selectedInsumos.find(
                                                   (item) =>
                                                      item.id ===
                                                      data.id_primary,
                                                );
                                             const isSelected =
                                                !!selectedItem &&
                                                selectedItem.quantity > 0;

                                             if (muestroreg) {
                                                return (
                                                   <tr
                                                      key={data.id}
                                                      onClick={() =>
                                                         handleSelectInsumos(
                                                            data.id_primary,
                                                         )
                                                      }
                                                      style={{
                                                         backgroundColor:
                                                            isSelected
                                                               ? "#e8f5e8"
                                                               : "transparent",
                                                         fontWeight: isSelected
                                                            ? "bold"
                                                            : "normal",
                                                         border: isSelected
                                                            ? "2px solid #4CAF50"
                                                            : "1px solid #ddd",
                                                      }}
                                                   >
                                                      <td className={style.td2}>
                                                         {data.descripcion}
                                                      </td>
                                                      <td className={style.td2}>
                                                         {data.stock}
                                                      </td>
                                                      <td className={style.td2}>
                                                         {selectedItem &&
                                                         selectedItem.quantity >
                                                            0
                                                            ? `Qty: ${selectedItem.quantity}`
                                                            : "Qty: 0"}
                                                      </td>
                                                   </tr>
                                                );
                                             } else {
                                                return null;
                                             }
                                          })}
                                    </table>
                                 </div>
                              </div>

                              <div className={style.cliente}>
                                 <table>
                                    <tr>
                                       <td className={style.td1}>
                                          Descuentos %:{" "}
                                       </td>
                                       <td>
                                          <input
                                             className={style.clienteinput}
                                             onChange={(e) =>
                                                setDescto(e.target.value)
                                             }
                                             type="text"
                                             id="descuento"
                                             name="descuento"
                                             value={descto}
                                          />
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className={style.td1}>Seña: </td>
                                       <td>
                                          <input
                                             className={style.clienteinput}
                                             onChange={(e) =>
                                                setAdelanto(e.target.value)
                                             }
                                             type="text"
                                             id="adelanto"
                                             name="adelanto"
                                             value={adelanto}
                                          />
                                       </td>
                                    </tr>
                                 </table>
                              </div>
                              <div>
                                 <span>Observaciones : </span>&nbsp;
                                 <textarea
                                    className={style.textareaEx}
                                    type="text"
                                    placeholder="Ingrese una observación"
                                    name="observaciones"
                                    id="observaciones"
                                    cols={7}
                                    rows={12}
                                    value={input.observaciones}
                                    onChange={handleChange}
                                 />
                              </div>
                           </>
                        ) : null}
                     </div>
                     {input.cod_serv > 0 ? (
                        <div className={style.divDer}>
                           <div>
                              <table className={style.tableSel}>
                                 <tr>
                                    <td className={style.titulops} colSpan="4">
                                       Productos Seleccionados
                                    </td>
                                 </tr>
                                 <tr>
                                    {/* <td className="tdId">Id</td> */}
                                    <th>Descripcion</th>
                                    <th>Cantidad</th>
                                    <th className={style.thCenter}>Precio</th>
                                    <th>##</th>
                                 </tr>
                                 {factdet &&
                                    factdet.map((data, i) => {
                                       verremove = true;
                                       if (i === 0) verremove = false;
                                       if (data.tipo === 9999)
                                          verremove = false;
                                       return (
                                          <>
                                             <tr
                                                key={i}
                                                className={style.trGrid}
                                             >
                                                {/* <td>{data.id}</td> */}
                                                <td className={style.td1}>
                                                   &nbsp;{data.descripcion}
                                                </td>
                                                {data.descripcion ===
                                                "Insumos" ? (
                                                   <td>&nbsp;</td>
                                                ) : (
                                                   <td className={style.td1}>
                                                      <input
                                                         onChange={(e) =>
                                                            handleCant(e, { i })
                                                         }
                                                         className={style.cant}
                                                         value={data.cantidad}
                                                      />
                                                   </td>
                                                )}
                                                <td className={style.precios}>
                                                   <input
                                                      type="number"
                                                      step="0.01"
                                                      onChange={(e) =>
                                                         handlePrecio(e, { i })
                                                      }
                                                      className={style.importe}
                                                      value={data.dolar}
                                                   />
                                                   {/* {dollarUSLocale.format(
                                                   data.dolar
                                                )} */}
                                                </td>
                                                {verremove ? (
                                                   <td className="tdImg">
                                                      <img
                                                         onClick={() =>
                                                            handleRemove(
                                                               data.id,
                                                               data.tipo,
                                                            )
                                                         }
                                                         src={ImagenCerrar}
                                                         height="20px"
                                                         alt=""
                                                      />
                                                   </td>
                                                ) : (
                                                   <td>&nbsp;</td>
                                                )}
                                                &nbsp;&nbsp;&nbsp;
                                             </tr>
                                          </>
                                       );
                                    })}
                                 {factdet.insumosadic &&
                                    factdet.insumosadic.map((data, i) => {
                                       verremove = true;
                                       return (
                                          <>
                                             <tr
                                                key={i}
                                                className={style.trGrid}
                                             >
                                                {/* <td>{data.id}</td> */}
                                                <td className={style.td1}>
                                                   &nbsp;{data.descripcion}
                                                </td>

                                                   <td className={style.td1}>
                                                      <input
                                                         onChange={(e) =>
                                                            handleCant(e, { i })
                                                         }
                                                         className={style.cant}
                                                         value={data.cantidad}
                                                      />
                                                   </td>
                                                   
                                                <td className={style.precios}>
                                                   <input
                                                      type="number"
                                                      step="0.01"
                                                      onChange={(e) =>
                                                         handlePrecio(e, { i })
                                                      }
                                                      className={style.importe}
                                                      value={data.dolar}
                                                   />
                                                   
                                                </td>
                                                {verremove ? (
                                                   <td className="tdImg">
                                                      <img
                                                         onClick={() =>
                                                            handleRemove(
                                                               data.id,
                                                               data.tipo,
                                                            )
                                                         }
                                                         src={ImagenCerrar}
                                                         height="20px"
                                                         alt=""
                                                      />
                                                   </td>
                                                ) : (
                                                   <td>&nbsp;</td>
                                                )}
                                                &nbsp;&nbsp;&nbsp;
                                             </tr>
                                          </>
                                       );
                                    })}



                                 <tr>
                                    <td colSpan={5}>
                                       <hr />
                                    </td>
                                 </tr>
                                 {descto > 0 ? (
                                    <>
                                       <tr>
                                          <td>Descuento</td>
                                          <td>{descto} %</td>
                                          <td className={style.preciosdscto}>
                                             -
                                             {dollarUSLocale.format(totalDscto)}
                                          </td>
                                          <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                          <td colSpan={5}>
                                             <hr />
                                          </td>
                                       </tr>
                                    </>
                                 ) : null}
                                 {recargo > 0 ? (
                                    <>
                                       <tr>
                                          <td>{recargoDes}</td>
                                          <td>{recargo} %</td>
                                          <td className={style.precios}>
                                             {dollarUSLocale.format(
                                                totalRecargo,
                                             )}
                                          </td>
                                          <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                          <td colSpan={5}>
                                             <hr />
                                          </td>
                                       </tr>
                                    </>
                                 ) : null}
                                 <tr>
                                    <td>Total</td>
                                    <td>&nbsp;</td>
                                    <td className={style.preciosFinal}>
                                       {dollarUSLocale.format(totalFactura)}
                                    </td>
                                    <td colSpan={2}>&nbsp;</td>
                                 </tr>
                                 {adelanto > 0 ? (
                                    <>
                                       <tr>
                                          <td colSpan={5}>
                                             <hr />
                                          </td>
                                       </tr>
                                       <tr>
                                          <td>Adelanto</td>
                                          <td>&nbsp;</td>
                                          <td className={style.preciosdscto}>
                                             -{dollarUSLocale.format(adelanto)}
                                          </td>
                                          <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                          <td colSpan={5}>
                                             <hr />
                                          </td>
                                       </tr>
                                       <tr>
                                          <td>Resta Pagar</td>
                                          <td>&nbsp;</td>
                                          <td className={style.preciosFinal}>
                                             {dollarUSLocale.format(
                                                totalFactura - adelanto,
                                             )}
                                          </td>
                                          <td colSpan={2}>&nbsp;</td>
                                       </tr>
                                    </>
                                 ) : null}
                                 <tr>
                                    <td colSpan={5}>
                                       <hr />
                                    </td>
                                 </tr>
                                 <tr>
                                    <td colSpan={5}>
                                       <div
                                          style={{
                                             padding: "10px",
                                             backgroundColor: "#f9f9f9",
                                          }}
                                       >
                                          <p
                                             style={{
                                                fontWeight: "bold",
                                                marginBottom: "10px",
                                             }}
                                          >
                                             Opciones de Pago
                                          </p>
                                          <table
                                             style={{
                                                width: "100%",
                                                borderCollapse: "collapse",
                                             }}
                                          >
                                             <tbody>
                                                {pagos &&
                                                   pagos.map((pago) => {
                                                      const estaSeleccionado =
                                                         pagosSeleccionados.some(
                                                            (p) =>
                                                               p.id_primary ===
                                                               pago.id_primary
                                                         );
                                                      const pagoSelec =
                                                         pagosSeleccionados.find(
                                                            (p) =>
                                                               p.id_primary ===
                                                               pago.id_primary
                                                         );

                                                      return (
                                                         <>
                                                            <tr
                                                               key={
                                                                  pago.id_primary
                                                               }
                                                               style={{
                                                                  borderBottom:
                                                                     "1px solid #ddd",
                                                               }}
                                                            >
                                                               <td
                                                                  style={{
                                                                     padding:
                                                                        "8px",
                                                                     cursor:
                                                                        "pointer",
                                                                     backgroundColor:
                                                                        estaSeleccionado
                                                                           ? "#e8f5e8"
                                                                           : "transparent",
                                                                  }}
                                                                  onClick={() =>
                                                                     handleSelectPago(
                                                                        pago.id_primary
                                                                     )
                                                                  }
                                                               >
                                                                  <input
                                                                     type="checkbox"
                                                                     checked={
                                                                        estaSeleccionado
                                                                     }
                                                                     onChange={() =>
                                                                        handleSelectPago(
                                                                           pago.id_primary
                                                                        )
                                                                     }
                                                                     style={{
                                                                        marginRight:
                                                                           "8px",
                                                                     }}
                                                                  />
                                                                  <span>
                                                                     {
                                                                        pago.descripcion
                                                                     }
                                                                  </span>
                                                               </td>
                                                               {estaSeleccionado ? (
                                                                  <td
                                                                     style={{
                                                                        padding:
                                                                           "8px",
                                                                        textAlign:
                                                                           "right",
                                                                     }}
                                                                  >
                                                                     <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        className={
                                                                           style.importe
                                                                        }
                                                                        value={
                                                                           pagoSelec?.importe ||
                                                                           0
                                                                        }
                                                                        onChange={(
                                                                           e
                                                                        ) =>
                                                                           handleImportePago(
                                                                              pago.id_primary,
                                                                              e
                                                                                 .target
                                                                                 .value
                                                                           )
                                                                        }
                                                                     />
                                                                  </td>
                                                               ) : (
                                                                  <td>&nbsp;</td>
                                                               )}
                                                            </tr>
                                                            {estaSeleccionado && pagoSelec?.porcentajeRecargo > 0 ? (
                                                               <tr
                                                                  style={{
                                                                     backgroundColor:
                                                                        "#f0f8ff",
                                                                  }}
                                                               >
                                                                  <td
                                                                     style={{
                                                                        padding:
                                                                           "6px 8px",
                                                                        fontSize:
                                                                           "12px",
                                                                        color:
                                                                           "#666",
                                                                     }}
                                                                  >
                                                                     &nbsp;&nbsp;Recargo ({pagoSelec.porcentajeRecargo}%): {dollarUSLocale.format(pagoSelec.montoRecargo)}
                                                                  </td>
                                                                  <td
                                                                     style={{
                                                                        padding:
                                                                           "6px 8px",
                                                                        textAlign:
                                                                           "right",
                                                                        fontWeight:
                                                                           "bold",
                                                                        color:
                                                                           "#d32f2f",
                                                                     }}
                                                                  >
                                                                     Total: {dollarUSLocale.format(pagoSelec.importeTotal)}
                                                                  </td>
                                                               </tr>
                                                            ) : null}
                                                         </>
                                                      );
                                                   })}
                                                {pagosSeleccionados.length >
                                                0 ? (
                                                   <>
                                                      <tr>
                                                         <td colSpan={2}>
                                                            <hr />
                                                         </td>
                                                      </tr>
                                                      <tr>
                                                         <td
                                                            style={{
                                                               padding: "8px",
                                                               fontWeight:
                                                                  "bold",
                                                            }}
                                                         >
                                                            Total Pagos
                                                         </td>
                                                         <td
                                                            style={{
                                                               padding: "8px",
                                                               textAlign:
                                                                  "right",
                                                               fontWeight:
                                                                  "bold",
                                                            }}
                                                         >
                                                            {dollarUSLocale.format(totalPagosSeleccionados)}
                                                         </td>
                                                      </tr>
                                                      {mostrarAvisoDiferencia ? (
                                                         <tr>
                                                            <td
                                                               style={{
                                                                  padding: "6px 8px",
                                                                  color: "#b91c1c",
                                                                  fontWeight: "bold",
                                                               }}
                                                            >
                                                               Diferencia con total presupuesto
                                                            </td>
                                                            <td
                                                               style={{
                                                                  padding: "6px 8px",
                                                                  textAlign: "right",
                                                                  color: "#b91c1c",
                                                                  fontWeight: "bold",
                                                               }}
                                                            >
                                                               {dollarUSLocale.format(diferenciaPagos)}
                                                            </td>
                                                         </tr>
                                                      ) : null}
                                                   </>
                                                ) : null}
                                             </tbody>
                                          </table>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td style={{ textAlign: "center" }}>
                                       {btnGrabar ? (
                                          <button
                                             className={style.inputBtnNew}
                                             disabled={botonDeshabilitado}
                                             style={{
                                                backgroundColor: botonDeshabilitado
                                                   ? "#9ca3af"
                                                   : "",
                                                cursor: botonDeshabilitado
                                                   ? "not-allowed"
                                                   : "pointer",
                                                opacity: botonDeshabilitado
                                                   ? 0.85
                                                   : 1,
                                             }}
                                             onClick={() => handleSubmit()}
                                             title={botonDeshabilitado ? "El total de pagos debe coincidir con el total del presupuesto" : ""}
                                          >
                                             {state ? "GRABAR" : "AGREGAR"}
                                          </button>
                                       ) : null}
                                    </td>
                                    { factdet.gc_id > 0 ? (
                                       <td style={{ textAlign: "center", color: usarGC ? "blue" : "black" }}>
                                          Gift Card : {dollarUSLocale.format(factdet.gc_total)}
                                          &nbsp;&nbsp;&nbsp;
                                          <input 
                                             type="checkbox"
                                             checked={usarGC}
                                             title="Usar el Gift Card"
                                             onChange={() => {
                                                if (!usarGC) {
                                                   // Checking: save original and subtract gc_total
                                                   setOriginalDolar(factdet[0].dolar);
                                                   factdet[0].dolar = parseFloat(factdet[0].dolar) - parseFloat(factdet.gc_total);
                                                } else {
                                                   // Unchecking: restore original
                                                   if (originalDolar !== null) {
                                                      factdet[0].dolar = originalDolar;
                                                      setOriginalDolar(null);
                                                   }
                                                }
                                                setUsarGC(!usarGC);
                                                setOnChange((prev) => !prev);
                                             }}
                                          />
                                       </td>
                                    ) : 

                                    <td
                                    colSpan={2}
                                    style={{ textAlign: "center" }}
                                    >
                                    </td>
                                    }
                                    <td
                                       colSpan={2}
                                       style={{ textAlign: "center" }}
                                    >
                                       <button
                                          className={style.inputBtnNew}
                                          onClick={() => {
                                             navigate("/presupuestot");
                                          }}
                                       >
                                          VOLVER
                                       </button>
                                    </td>
                                 </tr>
                              </table>
                           </div>
                        </div>
                     ) : null}
                  </div>
               )}
            </div>
         </div>
      </>
   );
}

export default ABMFacturas;
